<template>
  <div class="container">
    <h2 align="center">Students' Information</h2>
    <form classe="form-inline">
      <div class="form-group row">
        <div class="col-md-1">
          <label for="Group">Campus</label>
        </div>
        <div class="col-md-3">
          <select class="form-control input" v-model="Campus">
            <option v-for="Campus in campus_list" :key="Campus" v-bind:value="Campus">{{Campus}}</option>
          </select>
        </div>
        <div class="col-md-1">
          <label for="Group">Section</label>
        </div>
        <div class="col-md-3">
          <select class="form-control input" v-model="Section">
            <option
              v-for="Section in section_list"
              :key="Section"
              v-bind:value="Section"
            >{{Section}}</option>
          </select>
        </div>
        <div class="col-md-1">
          <label for="Group">Class</label>
        </div>
        <div class="col-md-3">
          <select class="form-control input" v-model="myclasse">
            <option v-for="StuClass in classes" :key="StuClass" v-bind:value="StuClass">{{StuClass}}</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-addon">Name</span>
            <input type="text" class="form-control" v-model="AdminStudent.Name" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="input-group">
            <span class="input-group-addon">Email</span>
            <input type="text" class="form-control" v-model="AdminStudent.Email" />
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-12">
          <div class="input-group">
            <span class="input-group-addon">Address</span>
            <input type="text" class="form-control" v-model="AdminStudent.Address" />
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-3">
          <div class="input-group">
            <span class="input-group-addon">Date of Birth</span>
            <input type="date" class="form-control" v-model="AdminStudent.Birth_Date" />
          </div>
        </div>
        <div class="col-md-3">
          <div class="input-group">
            <span class="input-group-addon">Birth Place</span>
            <input type="text" class="form-control" v-model="AdminStudent.Birth_Place" />
          </div>
        </div>
        <div class="col-md-1">
          <div class="form-check text-left form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="Gender"
              value="1"
              id="GenderMale"
              v-model="AdminStudent.Gender"
            />
            <label class="form-check-label" for="GenderMale">Male</label>
          </div>
        </div>
        <div class="col-md-1">
          <div class="form-check text-left form-check-inline">
            <input
              class="form-check-input"
              type="radio"
              name="Gender"
              value="0"
              id="GenderFemale"
              v-model="AdminStudent.Gender"
            />
            <label class="form-check-label" for="GenderFemale">Female</label>
          </div>
        </div>
        <div class="col-md-2">
          <label for="AY">Academic Year</label>
        </div>
        <div class="col-md-2">
          <select class="form-control input" id="AY" v-model="AdminStudent.AY">
            <option
              v-for="AY in ['2027/2028','2026/2027']"
              :key="AY"
              v-bind:value="AY"
            >{{AY}}</option>
          </select>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-5">
          <div class="input-group">
            <span class="input-group-addon">Previous School</span>
            <input type="text" class="form-control" v-model="AdminStudent.Prev_school" />
          </div>
        </div>
        <div class="col-md-7">
          <div class="input-group">
            <span class="input-group-addon">Reason of Transfer</span>
            <input type="text" class="form-control" v-model="AdminStudent.Res_of_Trans" />
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-5">
          <div class="input-group">
            <span class="input-group-addon">1st Foreign Language</span>
            <input type="text" class="form-control" v-model="AdminStudent.Foreign_Lang" />
          </div>
        </div>
        <div class="col-md-7">
          <div class="input-group">
            <span class="input-group-addon">Mother Tongue</span>
            <input type="text" class="form-control" v-model="AdminStudent.Mother_Lang" />
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="col-md-2">
          <div class="input-group">
            <span class="input-group-addon"># of Sibling</span>
            <input type="number" class="form-control" v-model="AdminStudent.Num_S_B" />
          </div>
        </div>
        <div class="col-md-10">
          <div class="input-group">
            <span class="input-group-addon">Sibling Schools</span>
            <input type="text" class="form-control" v-model="AdminStudent.S_B_School" />
          </div>
        </div>
      </div>
      <div class="form-group row">
        <div class="panel panel-success panel-default">
          <div class="panel-heading">
            <h3>Parents' Information</h3>
          </div>
          <div class="panel-body">
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Father Name</span>
                <input type="text" class="form-control" v-model="AdminStudent.FatherName" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Mother Name</span>
                <input type="text" class="form-control" v-model="AdminStudent.MotherName" />
              </div>
            </div>
            <!-- <div class="form-group row">   -->
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Father Email</span>
                <input type="text" class="form-control" v-model="AdminStudent.FatherEmail" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Mother Email</span>
                <input type="text" class="form-control" v-model="AdminStudent.MotherEmail" />
              </div>
            </div>
            <!-- </div>                      -->
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Father ID</span>
                <input type="text" class="form-control" v-model="AdminStudent.FatherID" />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Mother ID</span>
                <input type="text" class="form-control" v-model="AdminStudent.MotherID" />
              </div>
            </div>
            <div class="col-md-2">
              <label for="FNationality">Father Nationality</label>
            </div>
            <div class="col-md-4">
              <select
                id="FNationality"
                class="form-control input"
                v-model="AdminStudent.FatherNationality"
              >
                <option
                  v-for="Nationality in Nationalities"
                  :key="Nationality.id"
                  v-bind:value="Nationality.Name"
                >{{Nationality.Name}}</option>
              </select>
            </div>
            <div class="col-md-2">
              <label for="FNationality">Mother Nationality</label>
            </div>
            <div class="col-md-4">
              <select
                id="FNationality"
                class="form-control input"
                v-model="AdminStudent.MotherNationality"
              >
                <option
                  v-for="Nationality in Nationalities"
                  :key="Nationality.id"
                  v-bind:value="Nationality.Name"
                >{{Nationality.Name}}</option>
              </select>
            </div>
            <div class="col-md-3">
              <div class="form-check text-right form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="FatherReligion"
                  value="1"
                  id="FatherMuslim"
                  v-model="AdminStudent.FatherReligion"
                />
                <label class="form-check-label" for="FatherMuslim">Muslim</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-check text-left form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="FatherReligion"
                  value="0"
                  id="FatherChristian"
                  v-model="AdminStudent.FatherReligion"
                />
                <label class="form-check-label" for="FatherChristian">Christian</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-check text-right form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="MotherReligion"
                  value="1"
                  id="MotherMuslim"
                  v-model="AdminStudent.MotherReligion"
                />
                <label class="form-check-label" for="MotherMuslim">Muslim</label>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-check text-left form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  name="MotherReligion"
                  value="0"
                  id="MotherChristian"
                  v-model="AdminStudent.MotherReligion"
                />
                <label class="form-check-label" for="MotherChristian">Christian</label>
              </div>
            </div>
            <div class="col-md-2">
              <label for="FMarital">Marital Status</label>
            </div>
            <div class="col-md-4">
              <select
                id="FMarital"
                class="form-control input"
                v-model="AdminStudent.FatherMaritalStates"
              >
                <option
                  v-for="States in Maritals"
                  :key="States.ID"
                  v-bind:value="States.Name"
                >{{States.Name}}</option>
              </select>
            </div>
            <div class="col-md-2">
              <label for="MMarital">Marital Status</label>
            </div>
            <div class="col-md-4">
              <select
                id="MMarital"
                class="form-control input"
                v-model="AdminStudent.MotherMaritalStates"
              >
                <option
                  v-for="States in Maritals"
                  :key="States.ID"
                  v-bind:value="States.Name"
                >{{States.Name}}</option>
              </select>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Home Address</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="AdminStudent.FatherHomeAddress"
                  placeholder="Father Home Address"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Home Address</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="AdminStudent.MotherHomeAddress"
                  placeholder="Mother Home Address"
                />
              </div>
            </div>

            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Father Education</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="AdminStudent.FatherEducation"
                  placeholder="Father Education"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Mother Education</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="AdminStudent.MotherEducation"
                  placeholder="Mother Education"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Profession</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="AdminStudent.FatherProfession"
                  placeholder="Father Profession"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Profession</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="AdminStudent.MotherProfession"
                  placeholder="Mother Profession"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Company Name</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="AdminStudent.FatherOfficeAddress"
                  placeholder="Father Company Name"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Company Name</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="AdminStudent.MotherOfficeAddress"
                  placeholder="Mother Company Name"
                />
              </div>
            </div>
          </div>
          <!-- //parent info panel body -->
        </div>
      </div>
      <div class="form-group row">
        <div class="panel panel-success panel-default">
          <div class="panel-heading">
            <h3>Parents' Phones</h3>
          </div>
          <div class="panel-body">
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Home Phone</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="AdminStudent.FatherHomeTel"
                  placeholder="Father Home Telephone"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Home Phone</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="AdminStudent.MotherHomeTel"
                  placeholder="Mother Home Telephone"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Mobile</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="AdminStudent.FatherMobile"
                  placeholder="Father Mobile Number"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Mobile</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="AdminStudent.MotherMobile"
                  placeholder="Mother Mobile Number"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Office Telephone</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="AdminStudent.FatherOfficeTel"
                  placeholder="Father office Telephone"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="input-group">
                <span class="input-group-addon">Office Telephone</span>
                <input
                  type="text"
                  class="form-control"
                  v-model="AdminStudent.MotherOfficeTel"
                  placeholder="Mother office Telephone"
                />
              </div>
            </div>
          </div>
          <!-- //parent Phones panel body -->
        </div>
      </div>
      <div v-if="Showerror" :class="AlertClass">
        <!-- <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>-->
        <strong>{{this.errors}}</strong>
        click x to close this message-->
        <button
          type="button"
          class="close"
          v-on:click="Showerror=false"
        >x</button>
      </div>
      <!-- <v-alert v-if="Showalert" border="right" colored-border type="error" elevation="2">
        Thank you for your interest in GPIS. Kindly note that your online application has been submitted successfully.
        The admission for early years for SY 20-21 will start on Sunday, December 1st. You are kindly asked to visit our campus to start the admission process.
        Tours are available everyday from 9:00 am to 12:00 pm.
      </v-alert>-->
      <button v-on:click.prevent="savedata()" class="btn btn-primary btn-lg">Submit</button>
    </form>
  </div>
</template>

<script>
import db from "../firebase";
import Nationalities from "../nationality.js";

export default {
  firebase: {
    Students: db.ref("Students")
    // count: db.ref("count")
  },
  data() {
    return {
      AlertClass: "alert alert-danger",
      Campus: "",
      Section: "",
      classes: [],
      myclasse: "",
      Nationalities: Nationalities,
      Showerror: false,
      Showalert: false,
      formvalid: false,
      errors: "",
      Maritals: [
        { ID: 1, Name: "Married" },
        { ID: 2, Name: "Separated" },
        { ID: 3, Name: "Divorced" },
        { ID: 4, Name: "deceased " }
      ],
      AdminStudent: {
        AY: "",
        FormNo: 0,
        ApllicationDate: new Date()
          .toJSON()
          .slice(0, 10)
          .replace(/-/g, "/"),
        Campus: "",
        Section: "",
        Class: "",
        Name: "",
        Email: "",
        Address: "",
        Birth_Date: "",
        Birth_Place: "",
        Gender: 1,
        Prev_school: "",
        Res_of_Trans: "",
        Foreign_Lang: "",
        Mother_Lang: "",
        Num_S_B: 0,
        S_B_School: "",
        FatherName: "",
        MotherName: "",
        FatherEmail: "",
        MotherEmail: "",
        FatherID: "",
        MotherID: "",
        FatherNationality: "Egyptian",
        MotherNationality: "Egyptian",
        FatherReligion: 1,
        MotherReligion: 1,
        FatherMaritalStates: "Married",
        MotherMaritalStates: "Married",
        FatherEducation: "",
        MotherEducation: "",
        FatherProfession: "",
        MotherProfession: "",
        FatherHomeAddress: "",
        MotherHomeAddress: "",
        FatherOfficeAddress: "",
        MotherOfficeAddress: "",
        FatherHomeTel: "",
        MotherHomeTel: "",
        FatherMobile: "",
        MotherMobile: "",
        FatherOfficeTel: "",
        MotherOfficeTel: "",
        MailSent:"0" //Mail not send
      },
      campus_list: [
        "School Giza",
        "School Zayed",
        "Early Years Giza",
        "Early Years Zayed"
      ],
      section_list: ["English", "French"],
      E_school_classes: [
        "PYP4 / Grade1",
        "PYP5 / Grade2",
        "PYP6 / Grade3",
        "PYP7 / Grade4",
        "PYP8 / Grade5",
        "MYP1 / Grade6",
        "MYP2 / Grade7",
        "MYP3 / Grade8",
        "MYP4 / Grade9",
        "MYP5 / Grade10",
        "DP1 / Grade11",
        "DP2 / Grade12"
      ],
      E_nursery_Classes: ["PYP1 / Nursery", "PYP2 / KG1", "PYP3 / KG2"],
      F_school_classes: [
        "PP4 / Grade1",
        "PP5 / Grade2",
        "PP6 / Grade3",
        "PP7 / Grade4",
        "PP8 / Grade5",
        "PEI1 / Grade6",
        "PEI2 / Grade7",
        "PEI3 / Grade8",
        "PEI4 / Grade9",
        "PEI5 / Grade10"
      ],
      F_nursery_Classes: ["PP1 / Nursery", "PP2 / KG1", "PP3 / KG2"]
    };
  },
  watch: {
    // a computed getter
    Section: function() {
      if (this.Campus === "School Giza" || this.Campus === "School Zayed") {
        if (this.Section === "English") {
          this.classes = this.E_school_classes;
        } else {
          this.classes = this.F_school_classes;
        }
      } else if (
        this.Campus === "Early Years Giza" ||
        this.Campus === "Early Years Zayed"
      ) {
        if (this.Section === "English") {
          this.classes = this.E_nursery_Classes;
        } else {
          this.classes = this.F_nursery_Classes;
        }
      }
    },
    Campus: function() {
      this.Section = "";
    }
  },
  methods: {
    savedata() {
      this.Showerror = false;
      if (this.Campus === "Early Years Giza" || this.Campus == "Early Years Zayed") {
        this.AdminStudent.Campus = this.Campus ===  "Early Years Giza" ? "Nursery Giza" : "Nursery Zayed" ;
      } else {
        this.AdminStudent.Campus = this.Campus;
      }
      this.AdminStudent.Section = this.Section;
      this.AdminStudent.Class = this.myclasse;
      // console.log("compus :", this.Campus);
      if (!this.Campus) {
        this.errors = "You must select Campus";
        this.Showerror = true;
        this.formvalid = false;
        return false;
      } else {
        this.formvalid = true;
      }
      if (!this.Section) {
        this.errors = "You must select Section";
        this.Showerror = true;
        this.formvalid = false;
        return false;
      } else {
        this.formvalid = true;
      }
      // console.log(this.formvalid);
      if (!this.myclasse) {
        this.errors = "You must select Class";
        this.Showerror = true;
        return false;
        this.formvalid = false;
      } else {
        this.formvalid = true;
      }
      if (!this.AdminStudent.Name) {
        this.errors = "You must Enter Student Name";
        this.Showerror = true;
        return false;
        this.formvalid = false;
      } else {
        this.formvalid = true;
      }
      if (!this.AdminStudent.Birth_Date) {
        this.errors = "You must Enter Student Birth Date";
        this.Showerror = true;
        return false;
        this.formvalid = false;
      } else {
        this.formvalid = true;
      }
      if (!this.AdminStudent.AY) {
        this.errors = "You must Enter Academic Year";
        this.Showerror = true;
        return false;
        this.formvalid = false;
      } else {
        this.formvalid = true;
      }
      if (!this.AdminStudent.FatherName) {
        this.errors = "You must Enter Father Name";
        this.Showerror = true;
        return false;
        this.formvalid = false;
      } else {
        this.formvalid = true;
      }
      if (!this.AdminStudent.MotherName) {
        this.errors = "You must Enter Mother Name";
        this.Showerror = true;
        return false;
        this.formvalid = false;
      } else {
        this.formvalid = true;
      }
      if (!this.AdminStudent.FatherEmail) {
        this.errors = "You must Enter Father Email";
        this.Showerror = true;
        return false;
        this.formvalid = false;
      } else {
        this.formvalid = true;
      }
      if (!this.AdminStudent.MotherEmail) {
        this.errors = "You must Enter Mother Email";
        this.Showerror = true;
        return false;
        this.formvalid = false;
      } else {
        this.formvalid = true;
      }
      if (!this.AdminStudent.FatherHomeAddress) {
        this.errors = "You must Enter Father Home Address";
        this.Showerror = true;
        return false;
        this.formvalid = false;
      } else {
        this.formvalid = true;
      }
      if (!this.AdminStudent.MotherHomeAddress) {
        this.errors = "You must Enter Mother Home Address";
        this.Showerror = true;
        return false;
        this.formvalid = false;
      } else {
        this.formvalid = true;
      }
      if (!this.AdminStudent.FatherMobile) {
        this.errors = "You must Enter Father Mobile No.";
        this.Showerror = true;
        return false;
        this.formvalid = false;
      } else {
        this.formvalid = true;
      }
      if (!this.AdminStudent.MotherMobile) {
        this.errors = "You must Enter Mother Mobile No.";
        this.Showerror = true;
        return false;
        this.formvalid = false;
      } else {
        this.formvalid = true;
      }

      if (this.formvalid) {
        this.$firebaseRefs.Students.push(this.AdminStudent);
        // if (this.Campus === "Early Years Zayed") {
          this.errors =
            "Thank you for your interest in GPIS. Kindly note that your online application has been submitted successfully.The admission office will contact you shortly.";
        // } else {
          // this.errors = "Your application is successfully submitted";
        // }
        this.AlertClass = "alert alert-success";
        this.Showerror = true;
        this.Clear_Form();
      }
    },

    Clear_Form() {
      (this.AdminStudent.AY = ""),
        (this.Campus = ""),
        (this.Section = ""),
        (this.myclasse = ""),
        (this.AdminStudent.Name = ""),
        (this.AdminStudent.Email = ""),
        (this.AdminStudent.Address = ""),
        (this.AdminStudent.Birth_Date = ""),
        (this.AdminStudent.Birth_Place = ""),
        (this.AdminStudent.Gender = 1),
        (this.AdminStudent.Prev_school = ""),
        (this.AdminStudent.Res_of_Trans = ""),
        (this.AdminStudent.Foreign_Lang = ""),
        (this.AdminStudent.Mother_Lang = ""),
        (this.AdminStudent.Num_S_B = 0),
        (this.AdminStudent.S_B_School = ""),
        (this.AdminStudent.FatherName = ""),
        (this.AdminStudent.MotherName = ""),
        (this.AdminStudent.FatherEmail = ""),
        (this.AdminStudent.MotherEmail = ""),
        (this.AdminStudent.FatherID = ""),
        (this.AdminStudent.MotherID = ""),
        (this.AdminStudent.FatherNationality = 54),
        (this.AdminStudent.MotherNationality = 54),
        (this.AdminStudent.FatherReligion = 1),
        (this.AdminStudent.MotherReligion = 1),
        (this.AdminStudent.FatherMaritalStates = 1),
        (this.AdminStudent.MotherMaritalStates = 1),
        (this.AdminStudent.FatherEducation = ""),
        (this.AdminStudent.MotherEducation = ""),
        (this.AdminStudent.FatherProfession = ""),
        (this.AdminStudent.MotherProfession = ""),
        (this.AdminStudent.FatherHomeAddress = ""),
        (this.AdminStudent.MotherHomeAddress = ""),
        (this.AdminStudent.FatherOfficeAddress = ""),
        (this.AdminStudent.MotherOfficeAddress = ""),
        (this.AdminStudent.FatherHomeTel = ""),
        (this.AdminStudent.MotherHomeTel = ""),
        (this.AdminStudent.FatherMobile = ""),
        (this.AdminStudent.MotherMobile = ""),
        (this.AdminStudent.FatherOfficeTel = ""),
        (this.AdminStudent.MotherOfficeTel = "");
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.input-group-prepend {
  margin-bottom: 5px;
}
.panel {
  margin-bottom: 0%;
}
.panel-heading {
  background-color: #69ad72;
  color: antiquewhite;
}
.panel-body {
  background-color: #b6ddbc;
}
.form-group {
  margin-bottom: 5px;
  margin-left: 0px;
}
.input-group-addon {
  background-color: #def6e1;
}
.form-check {
  margin-top: 3px;
  margin-bottom: 1px;
}
h2 {
  /* align : center; */
  margin-top: 5px;
  margin-bottom: 5px;
  color: #047c14;
}
h3 {
  /* align : center; */
  margin-top: 5px;
  margin-bottom: 5px;
  color: #f2f8f3;
}
label {
  margin-left: 0px;
  margin-top: 5px;
  color: #047c14;
}
</style>




// WEBPACK FOOTER //
// src/components/HelloWorld.vue